import { aggregate } from "./../parallel/_private/aggregate.js";
import { all } from "./../parallel/_private/all.js";
import { allAsync } from "./../parallel/_private/allAsync.js";
import { append } from "./../parallel/_private/append.js";
import { any } from "./../parallel/_private/any.js";
import { anyAsync } from "./../parallel/_private/anyAsync.js";
import { asAsync } from "./../parallel/_private/asAsync.js";
import { average } from "./../parallel/_private/average.js";
import { averageAsync } from "./../parallel/_private/averageAsync.js";
import { chunk } from "./../parallel/_private/chunk.js";
import { concatenate } from "../parallel/_private/concatenate.js";
import { contains } from "./../parallel/_private/contains.js";
import { containsAsync } from "./../parallel/_private/containsAsync.js";
import { count } from "./../parallel/_private/count.js";
import { countAsync } from "./../parallel/_private/countAsync.js";
import { defaultIfEmpty } from "./../parallel/_private/defaultIfEmpty.js";
import { distinct } from "./../parallel/_private/distinct.js";
import { distinctAsync } from "./../parallel/_private/distinctAsync.js";
import { each } from "./../parallel/_private/each.js";
import { eachAsync } from "./../parallel/_private/eachAsync.js";
import { elementAt } from "./../parallel/_private/elementAt.js";
import { elementAtOrDefault } from "./../parallel/_private/elementAtOrDefault.js";
import { except } from "./../parallel/_private/except.js";
import { exceptAsync } from "./../parallel/_private/exceptAsync.js";
import { first } from "./../parallel/_private/first.js";
import { firstAsync } from "./../parallel/_private/firstAsync.js";
import { firstOrDefault } from "./../parallel/_private/firstOrDefault.js";
import { firstOrDefaultAsync } from "./../parallel/_private/firstOrDefaultAsync.js";
import { groupBy } from "./../parallel/_private/groupBy.js";
import { groupByAsync } from "./../parallel/_private/groupByAsync.js";
import { groupByWithSel } from "./../parallel/_private/groupByWithSel.js";
import { groupJoin } from "./../parallel/_private/groupJoin.js";
import { groupJoinAsync } from "./../parallel/_private/groupJoinAsync.js";
import { intersect } from "./../parallel/_private/intersect.js";
import { intersectAsync } from "./../parallel/_private/intersectAsync.js";
import { join } from "./../parallel/_private/join.js";
import { last } from "./../parallel/_private/last.js";
import { lastAsync } from "./../parallel/_private/lastAsync.js";
import { lastOrDefault } from "./../parallel/_private/lastOrDefault.js";
import { lastOrDefaultAsync } from "./../parallel/_private/lastOrDefaultAsync.js";
import { max } from "./../parallel/_private/max.js";
import { maxAsync } from "./../parallel/_private/maxAsync.js";
import { min } from "./../parallel/_private/min.js";
import { minAsync } from "./../parallel/_private/minAsync.js";
import { ofType } from "./../parallel/_private/ofType.js";
import { order } from "./../parallel/_private/order.js";
import { orderBy } from "./../parallel/_private/orderBy.js";
import { orderByAsync } from "./../parallel/_private/orderByAsync.js";
import { orderByDescending } from "./../parallel/_private/orderByDescending.js";
import { orderByDescendingAsync } from "./../parallel/_private/orderByDescendingAsync.js";
import { orderDescending } from "./../parallel/_private/orderDescending.js";
import { partition } from "./../parallel/_private/partition.js";
import { partitionAsync } from "./../parallel/_private/partitionAsync.js";
import { prepend } from "./../parallel/_private/prepend.js";
import { reverse } from "./../parallel/_private/reverse.js";
import { select } from "./../parallel/_private/select.js";
import { selectAsync } from "./../parallel/_private/selectAsync.js";
import { selectMany } from "./../parallel/_private/selectMany.js";
import { selectManyAsync } from "./../parallel/_private/selectManyAsync.js";
import { sequenceEquals } from "./../parallel/_private/sequenceEquals.js";
import { sequenceEqualsAsync } from "./../parallel/_private/sequenceEqualsAsync.js";
import { single } from "./../parallel/_private/single.js";
import { singleAsync } from "./../parallel/_private/singleAsync.js";
import { singleOrDefault } from "./../parallel/_private/singleOrDefault.js";
import { singleOrDefaultAsync } from "./../parallel/_private/singleOrDefaultAsync.js";
import { skip } from "./../parallel/_private/skip.js";
import { skipWhile } from "./../parallel/_private/skipWhile.js";
import { skipWhileAsync } from "./../parallel/_private/skipWhileAsync.js";
import { sum } from "./../parallel/_private/sum.js";
import { sumAsync } from "./../parallel/_private/sumAsync.js";
import { take } from "./../parallel/_private/take.js";
import { takeWhile } from "./../parallel/_private/takeWhile.js";
import { takeWhileAsync } from "./../parallel/_private/takeWhileAsync.js";
import { toArray } from "./../parallel/_private/toArray.js";
import { toMap } from "./../parallel/_private/toMap.js";
import { toMapAsync } from "./../parallel/_private/toMapAsync.js";
import { toObject } from "./../parallel/_private/toObject.js";
import { toObjectAsync } from "./../parallel/_private/toObjectAsync.js";
import { toSet } from "./../parallel/_private/toSet.js";
import { union } from "./../parallel/_private/union.js";
import { unionAsync } from "./../parallel/_private/unionAsync.js";
import { where } from "./../parallel/_private/where.js";
import { whereAsync } from "./../parallel/_private/whereAsync.js";
import { zip } from "./../parallel/_private/zip.js";
import { zipAsync } from "./../parallel/_private/zipAsync.js";
export const bindLinqParallel = (object) => {
    const prototype = object.prototype;
    const bind = (func, key) => {
        const wrapped = function (...params) {
            return func(this, ...params);
        };
        Object.defineProperty(wrapped, "length", { value: func.length - 1 });
        prototype[key] = wrapped;
    };
    bind(aggregate, "aggregate");
    bind(all, "all");
    bind(allAsync, "allAsync");
    bind(append, "append");
    bind(any, "any");
    bind(anyAsync, "anyAsync");
    bind(asAsync, "asAsync");
    bind(average, "average");
    bind(averageAsync, "averageAsync");
    bind(chunk, "chunk");
    bind(concatenate, "concatenate");
    bind(contains, "contains");
    bind(containsAsync, "containsAsync");
    bind(count, "count");
    bind(countAsync, "countAsync");
    bind(defaultIfEmpty, "defaultIfEmpty");
    bind(distinct, "distinct");
    bind(distinctAsync, "distinctAsync");
    bind(each, "each");
    bind(eachAsync, "eachAsync");
    bind(elementAt, "elementAt");
    bind(elementAtOrDefault, "elementAtOrDefault");
    bind(except, "except");
    bind(exceptAsync, "exceptAsync");
    bind(first, "first");
    bind(firstAsync, "firstAsync");
    bind(firstOrDefault, "firstOrDefault");
    bind(firstOrDefaultAsync, "firstOrDefaultAsync");
    bind(groupBy, "groupBy");
    bind(groupByAsync, "groupByAsync");
    bind(groupByWithSel, "groupByWithSel");
    bind(groupJoin, "groupJoin");
    bind(groupJoinAsync, "groupJoinAsync");
    bind(groupJoin, "groupJoin");
    bind(groupJoinAsync, "groupJoinAsync");
    bind(intersect, "intersect");
    bind(intersectAsync, "intersectAsync");
    bind(join, "joinByKey");
    bind(last, "last");
    bind(lastAsync, "lastAsync");
    bind(lastOrDefault, "lastOrDefault");
    bind(lastOrDefaultAsync, "lastOrDefaultAsync");
    bind(max, "max");
    bind(maxAsync, "maxAsync");
    bind(min, "min");
    bind(minAsync, "minAsync");
    bind(ofType, "ofType");
    bind(order, "order");
    bind(orderBy, "orderBy");
    bind(orderByAsync, "orderByAsync");
    bind(orderByDescending, "orderByDescending");
    bind(orderByDescendingAsync, "orderByDescendingAsync");
    bind(orderDescending, "orderDescending");
    bind(partition, "partition");
    bind(partitionAsync, "partitionAsync");
    bind(prepend, "prepend");
    bind(reverse, "reverse");
    bind(select, "select");
    bind(selectAsync, "selectAsync");
    bind(selectMany, "selectMany");
    bind(selectManyAsync, "selectManyAsync");
    bind(sequenceEquals, "sequenceEquals");
    bind(sequenceEqualsAsync, "sequenceEqualsAsync");
    bind(single, "single");
    bind(singleAsync, "singleAsync");
    bind(singleOrDefault, "singleOrDefault");
    bind(singleOrDefaultAsync, "singleOrDefaultAsync");
    bind(skip, "skip");
    bind(skipWhile, "skipWhile");
    bind(skipWhileAsync, "skipWhileAsync");
    bind(sum, "sum");
    bind(sumAsync, "sumAsync");
    bind(take, "take");
    bind(takeWhile, "takeWhile");
    bind(takeWhileAsync, "takeWhileAsync");
    bind(toArray, "toArray");
    bind(toMap, "toMap");
    bind(toMapAsync, "toMapAsync");
    bind(toObject, "toObject");
    bind(toObjectAsync, "toObjectAsync");
    bind(toSet, "toSet");
    bind(union, "union");
    bind(unionAsync, "unionAsync");
    bind(where, "where");
    bind(whereAsync, "whereAsync");
    bind(zip, "zip");
    bind(zipAsync, "zipAsync");
};
